<template>
  <div class="dashboard-container">
    <div class="tip">{{ dash.title }}</div>
    <component :is="currentRole" :dash="dash" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import admin from './components/admin'
import user from './components/user'

export default {
  name: 'Dashboard',
  components: { admin, user },
  data() {
    return {
      currentRole: 'admin'
    }
  },
  computed: {
    ...mapGetters([
      'role'
    ]),
    ...mapState({
      dash: state => state.work.dash
    })
  },
  created() {
    if (!this.role.includes('admin')) {
      this.currentRole = 'user'
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;
  background-color: #f0f2f5;

  .tip {
    text-align: right;
    margin: 10px;
    font-size: 14px;
    color: #5a5e66;
  }
}
</style>
